<template>
  <div class="scan-filter-wrapper">
    <button class="scan-filter-btn" @click="showSelectFilter" v-show="!isShowSelectFilter">
      <i class="fas fa-sliders-h"></i>
    </button>
    <div class="select-filter-wrapper" v-show="isShowSelectFilter">
      <div class="box">
        <header>
          Filtros
          <button type="button" class="close text-dark" @click="hideSelectFilter">
            <img src="@/assets/images/icon/close.svg" alt="fechar"/>
          </button>
        </header>
        <div class="content">
          <div class="label">Tags</div>
          <div class="tags-select-box">
            <!-- Multiselect com CHECKBOX padrão da plataforma (IMultiselect):
                 abre a lista com uma caixinha de check por tag. Sem busca. -->
            <i-multiselect
              v-model="tagsSelected"
              :options="msOptions"
              :filter="false"
              placeholder="Selecionar tags..."
            />
          </div>
          <div class="button-box">
            <button type="button" class="scan-btn scan-btn-outline" @click="limparFiltro">LIMPAR FILTROS</button>
          </div>
          <button type="button" class="scan-btn" @click="aplicarFiltro">APLICAR FILTROS</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import IMultiselect from '@/components/inputs/IMultiselect'
import { CHECK_IN_MODULE } from '@/modules/check-in'

export default {
  name: 'scan-filter',
  components: { IMultiselect },
  props: {
    // Tags atualmente aplicadas (vindas do scan.vue). Quando o modal abre,
    // sincronizamos `tagsSelected` a partir daqui para que a UI sempre
    // reflita o estado autoritativo do pai (e o usuário veja a tag
    // memorizada/já aplicada já marcada).
    filter: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    isShowSelectFilter: false,
    // IDs das tags selecionadas (v-model do IMultiselect).
    tagsSelected: []
  }),
  computed: {
    ...mapGetters(CHECK_IN_MODULE, ['stationMode', 'giftCatalog']),
    ...mapState(CHECK_IN_MODULE, {
      allTags: state => state.tags.list
    }),
    // Opções por modo: brinde mostra SÓ as tags-brinde (catálogo); check-in e
    // coleta de lead mostram só as NÃO-brinde (tag de brinde não é filtro deles).
    filterOptions () {
      const all = this.allTags || []
      const giftIds = new Set((this.giftCatalog || []).map(g => g.id))
      if (this.stationMode === 'brinde') {
        return all.filter(t => giftIds.has(t.id))
      }
      return all.filter(t => !giftIds.has(t.id))
    },
    // Formato do IMultiselect: { value, label }.
    msOptions () {
      return (this.filterOptions || []).map(t => ({ value: t.id, label: t.text }))
    }
  },
  methods: {
    ...mapActions(CHECK_IN_MODULE, ['loadTagsList', 'loadGiftCatalog']),
    hideSelectFilter () {
      this.isShowSelectFilter = false
      this.$emit('close')
    },

    showSelectFilter () {
      this.syncTagsSelectedFromFilter()
      this.isShowSelectFilter = true
    },

    // Sincroniza os IDs selecionados a partir do `filter` (array de IDs) do pai.
    syncTagsSelectedFromFilter () {
      this.tagsSelected = Array.isArray(this.filter) ? [...this.filter] : []
    },

    limparFiltro () {
      this.tagsSelected = []
      this.aplicarFiltro()
    },

    aplicarFiltro () {
      // tagsSelected já é um array de IDs (v-model do IMultiselect).
      this.$emit('filter', [...(this.tagsSelected || [])])
      this.hideSelectFilter()
    }
  },
  beforeMount () {
    this.loadTagsList()
    this.loadGiftCatalog() // pro filtro por classificação (excluir/incluir brindes)
  }
}
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/functions";
@import "src/design/variables";

.scan-filter-wrapper {
}

.scan-filter-btn {
  position: absolute;
  @media (min-width: map-get($grid-breakpoints, "md")) {
    top: 63px;
    right: 68px;
  }
  top: 23px;
  right: 21px;
  background-color: #564AB1;
  color: #fff;
  border: 0;
  border-radius: 7px;
  display: grid;
  place-items: center;
  font-size: 24px;
  padding: 18px 19px;
  box-shadow: 0 4px 4px 0 #00000040;
}

.select-filter-wrapper {
  position: absolute;
  width: 100%;

  .box {
    @media (min-width: map-get($grid-breakpoints, "md")) {
      --size-width: 560px;
      --size-height: auto;
      --size-top: 240px;
      --size-margin: auto;
    }
    --size-width: auto;
    --size-height: auto;
    --size-top: 149px;
    --size-margin: 8px;

    width: var(--size-width);
    height: var(--size-height);
    /* visible (não auto): a caixa não pode cortar a LISTA do multiselect (que é
       posicionada absoluta dentro dela). */
    overflow: visible;
    margin: var(--size-top) var(--size-margin) 0;
    background: #FFFFFF;
    border-radius: 5px;
    padding: 20px 18px;
  }

  header {
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: #292F42;
    margin-bottom: 10px;

    .close {
      opacity: 1;
    }
  }

  .label {
    font-size: 14px;
    font-weight: 400;
    color: #292F42;
    margin-bottom: 8px;
  }

  .tags-select-box {
    margin-bottom: 32px;
  }

  .button-box {
    margin-bottom: 8px;
  }

  button.scan-btn {
    display: block;
    width: 100%;
    border: 2px solid transparent;
    border-radius: 4px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    padding: 12px;
    background-color: #292F42;
    color: #fff;
    &.scan-btn-outline {
      background-color: #fff;
      color: #292F42;
      border-color: #292F42;
    }
  }
}

</style>
